import React, { useEffect } from "react";
import Breadcrumbs from "../../common/Breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";

const Privacypolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);
  return (
    <div className="main-wrapper">
      <Breadcrumbs title="Privacy Policy" subtitle="Pages" />
      <div className="privacy-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="terms-policy">
                <p data-aos="fade-down">
                  Alharamain Cab respects your privacy. This policy explains how
                  we collect, use, and protect information when you request taxi
                  bookings, airport transfers, hotel transport, Ziyarat rides,
                  client dashboard access, or transport documents through our
                  website and support channels.
                </p>
                <p data-aos="fade-down">
                  We may collect your name, email address, phone number, pickup
                  and drop-off locations, pickup time, selected vehicle, booking
                  notes, passenger details, and uploaded documents when those
                  details are needed to arrange or manage your trip.
                </p>
                <p data-aos="fade-down">
                  We use this information to confirm bookings, assign drivers,
                  prepare transport documents, provide customer support, improve
                  our services, and contact you about your ride. We do not sell
                  customer information.
                </p>
                <ul data-aos="fade-down">
                  <li>
                    <span>
                      <i className="fa-solid fa-circle-check">
                      
                      </i>
                    </span>
                    Booking information is shared only with the team members,
                    drivers, and service partners needed to complete your trip.
                  </li>
                  <li>
                    <span>
                      <i className="fa-solid fa-circle-check">
                      
                      </i>
                    </span>
                    Payment, identity, and travel document details are handled
                    only for booking, operational, or legal requirements.
                  </li>
                  <li>
                    <span>
                      <i className="fa-solid fa-circle-check">
                      
                      </i>{" "}
                    </span>
                    We use reasonable safeguards to protect submitted data from
                    unauthorized access, loss, misuse, or disclosure.
                  </li>
                  <li>
                    <span>
                      <i className="fa-solid fa-circle-check">
                      
                      </i>{" "}
                    </span>
                    We may use cookies, analytics, and similar tools to maintain
                    the website, measure performance, and improve booking flows.
                  </li>
                  <li>
                    <span>
                      <i className="fa-solid fa-circle-check">
                      
                      </i>{" "}
                    </span>
                    You can contact us to request access, correction, or
                    deletion of your personal information where applicable.
                  </li>
                  <li>
                    <span>
                      <i className="fa-solid fa-circle-check">
                      
                      </i>{" "}
                    </span>
                    We may update this policy when our services, legal
                    requirements, or operational processes change.
                  </li>
                </ul>
                <p data-aos="fade-down">
                  Some services may require communication through phone,
                  WhatsApp, email, or third-party providers. Those providers may
                  process information according to their own privacy terms.
                </p>
                <p className="mb-0" data-aos="fade-down">
                  For privacy questions, contact Alharamain Cab at
                  support@alharamaincab.com.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacypolicy;
